import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,{attrs:{"items":_vm.value.children,"item-text":"name","item-value":"id","label":_vm.$t('Default variant'),"outlined":"","hide-details":"","clearable":""},model:{value:(_vm.defaultVariant),callback:function ($$v) {_vm.defaultVariant=$$v},expression:"defaultVariant"}})}
var staticRenderFns = []

export { render, staticRenderFns }